import React, { Component } from "react";
import PropTypes from "prop-types";
import { deleteFont, fontGetAdded } from "../../../../_actions/appActions";
import { connect } from "react-redux";
import { fetchBrandkitById, fetchBrandKits, switchBrandkit } from "../../../../_actions/brandKitActions";
import { wsAddLayer } from "../../../../_actions/webSocketAction";
import { defaultBodyTextItem } from "../../../canvas/constants/defaults";
import { closeSlider } from "../../../../_actions/sidebarSliderActions";
import { Flex, Spinner, Text, VStack } from "@chakra-ui/react";
import { FaTrash } from "react-icons/fa";
import { getFontVariants } from "apps/simplified-web/src/_utils/common";
import { FONT_REGULAR_WEIGHT } from "../../constants";

const TEXT_COMMON_PHRASE = "The quick brown fox jumps over the lazy dog";

class TextMyFont extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleting: false,
    };
  }

  render() {
    const { font, workspacePermissionChecks, className } = this.props;
    const { payload, id } = font;
    const { isDeleting } = this.state;
    const { canDeleteBrandKitFont = true } = workspacePermissionChecks;

    return (
      <div
        className={`item my-fonts-item ${className}`}
        onClick={() => this.onTextClick()}
        style={{
          marginBottom: "0.5rem"
        }}
      >
        <Flex
          direction="column"
          align="flex-start"
          justify="center"
          px="3"
          w="100%"
        >
          <Text
            fontFamily="Rubik"
            color="brand.white"
            py={["1", "2"]}
            fontSize={["14px", "16px"]}
          >
            {payload.family}
          </Text>
          <Text
            fontFamily={payload.family}
            color="brand.white"
            py={["1", "2"]}
            fontSize={["16px", "18px"]}
          >
            {TEXT_COMMON_PHRASE}
          </Text>
        </Flex>
        {canDeleteBrandKitFont && (
          <div className="font-actions">
            {isDeleting ? (
              <Spinner size="sm" color="primary" />
            ) : (
              <FaTrash onClick={(event) => this.onClickDeleteFont(event, id)} />
            )}
          </div>
        )}
      </div>
    );
  }

  onTextClick = () => {
    const { addToArtboard, editor } = this.props;

    if (addToArtboard) {
      if (editor.activeElement.mime === "text") {
        this.changeFont();
      } else {
        this.addTextElement();
      }
    }
  };

  changeFont = () => {
    const { canvasRef, fonts, font, editor } = this.props;
    if (!canvasRef) {
      return;
    }

    const variants = getFontVariants(fonts, font.family);

    let { fontWeight } = editor.activeElement.format;

    fontWeight = !canvasRef.handler.textHandler.currentFontVariantExists(
      fontWeight,
      variants
    )
      ? FONT_REGULAR_WEIGHT
      : fontWeight;

    canvasRef.handler.textHandler.font(
      font.family,
      fontWeight,
      font.id
    );
  };

  addTextElement = () => {
    const { font, activePage } = this.props;
    if (!activePage) {
      // If there is no active page, Don't add text element
      return;
    }
    const { family, payload: fontPayload, id: fontId } = font;
    const { payload, id: activePageId } = activePage;

    const minSize = Math.min(payload.height, payload.width);

    let textPayload = Object.assign({}, defaultBodyTextItem);
    textPayload.payload.fontSize = minSize * 0.05;
    textPayload.payload.text = TEXT_COMMON_PHRASE;
    textPayload.payload.fontFamily = family;
    textPayload.payload.fontId = fontId;

    // Filter variant which doesn't have italic
    let variants = fontPayload.variants.filter(
      (variant, index) => !variant.toString().includes("italic")
    );

    if (variants?.length > 0) {
      textPayload.payload.fontWeight =
        variants[0] === "regular" ? 400 : Number(variants[0]);
    }

    this.props.wsAddLayer(activePageId, textPayload);
    if (this.props.isMobileView) {
      this.props.closeSlider();
    }
  };

  onClickDeleteFont = (event, fontId) => {
    event.stopPropagation();
    const { brandKitId, deleteFont, fetchBrandKits, fetchBrandkitById, switchBrandkit } = this.props;

    this.setState(
      {
        ...this.state,
        isDeleting: true,
      },
      () => {
        deleteFont(fontId).then(() => {
          if (brandKitId) {
            fetchBrandKits();
            fetchBrandkitById(brandKitId)
              .then((responseData) => {
                switchBrandkit(responseData);
              });
          }
          this.setState({
            ...this.state,
            isDeleting: false,
          });
        });
      }
    );
  };
}

TextMyFont.propTypes = {
  activePage: PropTypes.object.isRequired,
};

TextMyFont.defaultProps = {
  brandKitId: null,
};

const mapStateToProps = (state) => ({
  activePage: state.pagestore.pages[state.editor.activePage?.id],
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  isMobileView: state.app.isMobileView,
  editor: state.editor,
  fonts: state.app.fonts,
});

const mapDispatchToProps = (dispatch) => ({
  deleteFont: (fontId, props) => dispatch(deleteFont(fontId, props)),
  fetchBrandKits: () => dispatch(fetchBrandKits()),
  wsAddLayer: (pageId, message) => dispatch(wsAddLayer(pageId, message)),
  closeSlider: () => dispatch(closeSlider()),
  fetchBrandkitById: (id) => dispatch(fetchBrandkitById(id)),
  switchBrandkit: (payload) => dispatch(switchBrandkit(payload)),
  fontGetAdded: (fontInfo) => dispatch(fontGetAdded(fontInfo)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TextMyFont);
